import React from 'react';
import {useHistory} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {Button} from 'primereact/button';
import {Message} from 'primereact/message';

export function closeReceipt(history) {
  const params = new URLSearchParams(history.location.search);
  const backlink = params.get('backlink');
  params.delete('backlink');
  const isSafeOrigin = value => typeof value === 'string' &&
    /^\/(finance|project|procurement)(\/|\?|$)/.test(value) &&
    !value.includes('\\') && !/[\r\n]/.test(value) &&
    !/\/(receipt|invoice-approval)\/(read|update|create)(\/|\?|$)/.test(value) &&
    !/[?&](update|create)=receipt(?:&|$)/.test(value);
  const from = history.location.state?.from;
  const fallback = history.location.pathname.startsWith('/finance/invoice-approval/')
    ? '/finance/invoice-approval'
    : '/finance' + (params.toString() ? '?' + params.toString() : '');
  const target = isSafeOrigin(from) ? from : isSafeOrigin(backlink) ? backlink : fallback;
  window.App.setState({sidebarReceiptUpdate: false, sidebarReceiptCreate: false, sidebarReceiptShow: false,
    props: {}, rerenderReceiptList: true});
  history.replace(target);
}
export default function ReceiptUnavailable() {
  const history = useHistory();
  const {t} = useTranslation('common');
  return <div className="p-p-4">
    <Message severity="warn" text={t('receiptUnavailable')} />
    <div className="p-mt-3"><Button label={t('backToList')} icon="pi pi-arrow-left" onClick={() => closeReceipt(history)} /></div>
  </div>;
}
